<template>
  <div class="pinwall__download">
    <h1>{{ $t("download") }}</h1>
    <b-button
      :disabled="selectedIds.length === 0 && !isDownloading"
      :loading="isDownloading"
      class="download-button action-button is-success is-rounded"
      icon-left="download"
      :title="$t('download')"
      @click="download"
      >{{
        windowWidth > 450
          ? `${selectedIds.length} ${$t("download")}`
          : `${selectedIds.length}`
      }}</b-button
    >
    <b-checkbox v-model="isAll" type="is-info" class="all" @input="selectAll">
      {{ $t("all") }}
    </b-checkbox>
    <b-dropdown
      aria-role="list"
      class="sort"
      v-model="sort"
      @change="sortPosts"
      position="is-bottom-left"
    >
      <button class="button is-primary is-rounded sort-button" slot="trigger">
        <span>{{
          sort !== "" ? $t(`sort.${sort}`) : $t("sort.creative")
        }}</span>
        <b-icon icon="menu-down"></b-icon>
      </button>
      <b-dropdown-item disabled>{{ $t("sort.sorting") }}</b-dropdown-item>
      <b-dropdown-item value aria-role="listitem">{{
        $t("sort.creative")
      }}</b-dropdown-item>
      <b-dropdown-item value="new" aria-role="listitem">{{
        $t("sort.new")
      }}</b-dropdown-item>
      <b-dropdown-item value="old" aria-role="listitem">{{
        $t("sort.old")
      }}</b-dropdown-item>
      <b-dropdown-item value="likes" aria-role="listitem">{{
        $t("sort.likes")
      }}</b-dropdown-item>
      >
    </b-dropdown>
    <ul>
      <li
        v-for="post in posts"
        :id="post.id"
        :key="post.id"
        :style="post.style"
      >
        <b-field>
          <b-checkbox
            type="is-info"
            v-model="selectedIds"
            :native-value="post.id"
          >
            <div>
              <img
                :title="
                  post.image.fileName
                    ? post.image.fileName.substring(post.id.length + 1)
                    : ''
                "
                v-if="post.image"
                :src="
                  post.image.source
                    .replace('.jpg', '.webp')
                    .replace('.png', '.webp')
                "
                @error="
                  post.image.type === 'local'
                    ? replaceByDefault($event, post)
                    : ''
                "
              />
              <b-icon
                v-if="!post.image"
                :title="
                  post.file
                    ? post.file.fileName.substring(post.id.length + 1)
                    : ''
                "
                icon="file"
                class="file"
                size="is-large"
              ></b-icon>
              <div class="like" v-if="post.image">
                <b-icon
                  class="like-icon"
                  icon="thumb-up"
                  size="is-small"
                ></b-icon>
                <span>{{ post.likes || 0 }}</span>
              </div>
              <p v-html="getText(post)"></p></div
          ></b-checkbox>
        </b-field>
      </li>
    </ul>
    <b-button
      :disabled="selectedIds.length === 0 && !isDownloading"
      :loading="isDownloading"
      class="download-bottom-button action-button is-success is-rounded"
      icon-left="download"
      :title="$t('download')"
      @click="download"
      >{{ `${selectedIds.length} ${$t("download")}` }}</b-button
    >
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Download",
  data: () => {
    return {
      ids: [],
      posts: [],
      selectedIds: [],
      isAll: false,
      sort: "new",
      pinwall: null,
      isDownloading: false
    };
  },
  props: {
    tenantId: {
      type: String,
      default: null
    },
    space: {
      type: String,
      default: null
    },
    pinwallId: {
      type: String,
      default: null
    },
    password: {
      type: String,
      default: null
    }
  },
  methods: {
    ...mapActions(["loadPinwall", "downloadPosts"]),
    getText(post) {
      if (post.text) {
        return post.text;
      } else if (post.video && post.video.type && post.video.type === "local") {
        return post.video.fileName.substring(post.id.length + 1);
      } else if (post.audio && post.audio.type && post.audio.type === "local") {
        return post.audio.fileName.substring(post.id.length + 1);
      } else if (post.image && post.image.type && post.image.type === "local") {
        return post.image.fileName.substring(post.id.length + 1);
      } else if (post.file) {
        return post.file.fileName.substring(post.id.length + 1);
      }
    },
    replaceByDefault(e, post) {
      let fileExtensions =
        post.image.mimeType && post.image.mimeType.includes("png")
          ? ".png"
          : ".jpg";

      e.target.src = post.image.source.replace(".webp", fileExtensions);
    },
    selectAll(input) {
      this.isAll = input;
      this.selectedIds = input
        ? this.posts.map(post => {
            return post.id;
          })
        : [];
    },
    sortPosts(sort) {
      if (sort === "new") {
        this.posts = this.posts.sort(function(a, b) {
          return new Date(b.createDate) - new Date(a.createDate);
        });
      }

      if (sort === "old") {
        this.posts = this.posts.sort(function(a, b) {
          return new Date(a.createDate) - new Date(b.createDate);
        });
      }

      if (sort === "likes") {
        this.posts = this.posts.sort(function(a, b) {
          return new Date(b.likes) - new Date(a.likes);
        });
      }

      if (sort === "creative") {
        this.posts = this.pinwall.posts;
      }
    },
    download() {
      this.isDownloading = true;
      let posts = [];

      this.selectedIds.map(id => {
        var post = this.posts.find(post => {
          return post.id === id;
        });

        if (post) {
          posts.push(post);
        }
      });

      this.downloadPosts({
        tenant: this.tenantId,
        posts: posts
      }).then(bytes => {
        let elm = document.createElement("a");
        elm.href = URL.createObjectURL(bytes);
        elm.setAttribute("download", `${this.pinwallId}.zip`);
        elm.click();
        this.isDownloading = false;
        this.selectedIds = [];
        this.isAll = false;
      });
    },
    load() {
      this.loadPinwall({
        tenant: this.tenantId,
        space: this.space,
        pinwallId: this.pinwallId,
        password: this.password,
        sort: "",
        view: "",
        initialLoad: true,
        mounted: false,
        commit: false
      }).then(pinwall => {
        this.pinwall = pinwall;
        this.posts = pinwall.posts
          .filter(post => {
            // return post;
            return (
              (post.image && post.image.type && post.image.type === "local") ||
              post.file ||
              post.audio
            );
          })
          .sort(function(a, b) {
            return new Date(b.createDate) - new Date(a.createDate);
          });
      });
    }
  },
  mounted() {
    this.load();
  }
};
</script>
